import { render, staticRenderFns } from "./Toolbox.vue?vue&type=template&id=0afc60a4"
import script from "./Toolbox.vue?vue&type=script&lang=js"
export * from "./Toolbox.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports